var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 12 15",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.666 8.833H4a.667.667 0 0 0 0 1.333h2.666a.667.667 0 1 0 0-1.333Zm2.667-6.667h-.787A2 2 0 0 0 6.666.833H5.333a2 2 0 0 0-1.88 1.333h-.787a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h6.667a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2Zm-4.667.667a.667.667 0 0 1 .667-.667h1.333a.667.667 0 0 1 .667.667V3.5H4.666v-.667ZM10 12.166a.666.666 0 0 1-.667.667H2.666A.666.666 0 0 1 2 12.166v-8a.667.667 0 0 1 .666-.666h.667v.666A.667.667 0 0 0 4 4.833h4a.667.667 0 0 0 .666-.667V3.5h.667a.667.667 0 0 1 .667.666v8Zm-2-6H4A.667.667 0 0 0 4 7.5h4a.667.667 0 1 0 0-1.334Z"
})));

export default SvgFile;